webpackJsonp([64786156385128],{

/***/ 2081:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ValuesetDatumOption","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"flag","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"required","type":{"kind":"SCALAR","name":"Truthy","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-valueset-datum-option-8331a033ee1dd11735e8.js